import { ReactElement } from "react";
import { infoToolTipCardOptions } from "../../../interfaces/infoToolTipCardOptions";
import { Tooltip } from "@mui/material";
import ToolTipCard from "../ToolTipCard/ToolTipCard";
import * as Styles from "./ControlledToolTip.styles";

interface ControlledToolTipProps {
  children: ReactElement;
  open: boolean;
  content: infoToolTipCardOptions | string;
  color?: string;
  backgroundColor?: string;
}

export default function ControlledToolTip({ open, content, children, color, backgroundColor }: ControlledToolTipProps) {
  function getChosenInfoToolTipDisplayLayout() {
    if (typeof content === "object") {
      const cardContent = content as infoToolTipCardOptions;

      return (
        <ToolTipCard cardTitle={cardContent.cardTitle} cardSubtitle={cardContent.cardSubtitle} cardlistItems={cardContent.cardlistItems} />
      );
    }

    return content.toString();
  }

  return (
    <Tooltip
      title={getChosenInfoToolTipDisplayLayout()}
      arrow
      placement="bottom"
      open={open}
      slotProps={Styles.getToolTipStyle({ color, backgroundColor })}
      disableFocusListener
      disableHoverListener
      disableTouchListener
    >
      {children}
    </Tooltip>
  );
}
